const pathLines = `
<path d="M5 5.8c0-.5.3-.8.7-.8h14.5a.8.8 0 0 1 0 1.5H5.7a.8.8 0 0 1-.7-.8Z"/>
<path d="M9 14.8c0-.5.3-.8.7-.8h6.5a.8.8 0 0 1 0 1.5H9.7a.8.8 0 0 1-.7-.8Z"/>
<path d="M9 9.8c0-.5.3-.8.7-.8h6.5a.8.8 0 0 1 0 1.5H9.7a.8.8 0 0 1-.7-.8Z"/>
<path d="M5 18.8c0-.5.3-.8.7-.8h14.5a.8.8 0 0 1 0 1.5H5.7a.8.8 0 0 1-.7-.8Z"/>
`;
const pathLeft = `<path d="M5.5 14.5c-.2.2-.5 0-.5-.2V9.7c0-.2.3-.4.5-.2l2.3 2.3v.4l-2.3 2.3Z"/>`;
export const marginSideIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -2 25 25">
  <g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/>
    <path fill="currentcolor" d="m17.339 12.599 2.644 1.73c.452.296 1.017-.074 1.017-.665v-3.461c0-.591-.565-.961-1.017-.666l-2.644 1.73c-.452.297-.452 1.036 0 1.332M6.661 11.267l-2.644-1.73C3.565 9.241 3 9.611 3 10.202v3.461c0 .591.565.961 1.017.666L6.66 12.6c.452-.297.452-1.036 0-1.332"/>
    <path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.933 6h12M8.933 12h6M5.933 18h12"/>
  </g>
</svg>
`;
export const marginLeftSideIcon = `
<svg fill="currentColor" viewBox="0 0 24 24" style="transform:scale(1.125)">
${pathLines}
${pathLeft}
</svg>
`;
//# sourceMappingURL=icon.js.map